import { Divider } from '@chakra-ui/react';
import styled from '@emotion/styled';

const StyledDivider = styled(Divider)`
    width: calc(100% + 48px) !important;
    margin-left: -24px !important;
`;

export default StyledDivider;
